import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { Visibility, Edit, Add } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import { useParams } from 'react-router-dom';
import DocumentSerie from './DocumentSerie/DocumentSerie';
import { useModal } from 'hooks/useModal';
import Modal from './Modal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Documento', accessor: 'document' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Activo', accessor: 'active' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function DocumentPermission(props) {
  const classes = useStyles();
  const { id } = useParams();
  const [notify, showNotify] = useToasty();

  const [model, setOpen] = useModal();
  const [documentPermissions, setDocumentPermissions] = useState([]);
  const [documentSelected, setDocumentSelected] = useState(undefined);
  const [reloadChild, setReloadChild] = useState(false);

  async function listDocumentPermissions() {
    let response = await wsFindBy('prt/document-permission', 'oauth_user_id', id);
    if (response.success) setDocumentPermissions(response.data);
  }

  useEffect(() => {
    listDocumentPermissions();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={listDocumentPermissions}
        idUser={id}
        setReloadChild={setReloadChild}
        reloadChild={reloadChild}
        documentSelected={documentSelected}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de documentos</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              defaultWidth={1200}
              indexRow={[0, 4]}
              widthRow={[150, 5]}
              columns={columns}
              data={documentPermissions.map((docPermission, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.PRT_DOCUMENT_PERMISSIONS_SHOW}>
                        <Button
                          justIcon
                          round
                          simple
                          style={{ height: '0px' }}
                          color={
                            documentSelected?.document == docPermission.document
                              ? props.themeContext.buttonColorSuccess
                              : props.themeContext.buttonColor
                          }
                          onClick={() => setDocumentSelected(docPermission)}
                        >
                          <Visibility />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.PRT_DOCUMENT_PERMISSIONS_UPDATE}
                      >
                        <Button
                          justIcon
                          round
                          simple
                          style={{ height: '0px' }}
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(docPermission)}
                        >
                          <Edit />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.PRT_DOCUMENT_SERIE_PERMISSIONS_DELETED}
                      >
                        <ButtonDelete
                          entity="prt/document-permission"
                          id={docPermission.id}
                          reload={() => {
                            listDocumentPermissions();
                            if (documentSelected?.document == docPermission.document) {
                              setDocumentSelected(undefined);
                            }
                          }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  document: docPermission.document,
                  description: docPermission.description,
                  active: docPermission.active === 'Y' ? 'Si' : 'No',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
      {documentSelected !== undefined ? (
        <GridItem xs={12} key={reloadChild + documentSelected.document}>
          <DocumentSerie
            idDocumentP={documentSelected.document}
            showNotify={showNotify}
            idUser={id}
          />
        </GridItem>
      ) : undefined}
    </GridContainer>
  );
});
